// extracted by mini-css-extract-plugin
module.exports = {"whiteboard":"Whiteboard_whiteboard__1KWNz"};